var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
/**
 * Pack Complete Modal Component
 * Modal to complete packing and generate labels
 */
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Modal, Form, Checkbox, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import Dropdown from '@fp-suite/core-ui/src/components/Dropdown';
import Button from '@fp-suite/core-ui/src/components/Button';
import { usePackingState, usePackingActions, useLabelPrinting } from '../hooks';
import { isPalletPackingAllowed } from '../shared';
import { useNoClickDtcBetaEnabled } from '../../../utils/betaAccess';
export var PackCompleteModal = function (_a) {
    var _b, _c, _d, _e, _f, _g;
    var visible = _a.visible, onClose = _a.onClose;
    var t = useTranslation().t;
    var form = Form.useForm()[0];
    var _h = useState(false), isSubmitting = _h[0], setIsSubmitting = _h[1];
    var _j = usePackingState(), shipmentData = _j.shipmentData, shipmentPackages = _j.shipmentPackages, shippingMethods = _j.shippingMethods, shipmentTypeMethods = _j.shipmentTypeMethods, shipmentItemDetailList = _j.shipmentItemDetailList, shipmentItemSourceList = _j.shipmentItemSourceList, loading = _j.loading;
    var noClickDtcBetaEnabled = useNoClickDtcBetaEnabled();
    var isCompleteLoading = !!(loading === null || loading === void 0 ? void 0 : loading.markPacked) || isSubmitting;
    var handleMarkPacked = usePackingActions().handleMarkPacked;
    var _k = useLabelPrinting(), printAllLabels = _k.printAllLabels, printPackingSlip = _k.printPackingSlip;
    var isPalletShipment = isPalletPackingAllowed(shipmentData);
    // Pallet / SPS-carton shipments don't get carrier labels — force the
    // label-related checkboxes off and lock them. Local print follows the same
    // rule for pallet shipments since there's nothing carrier-side to print.
    useEffect(function () {
        if (!visible)
            return;
        if (isPalletShipment) {
            form.setFieldsValue({ getLabels: false, getReturnLabels: false });
        }
        if (isPalletShipment) {
            form.setFieldsValue({ getLocalPrints: false });
        }
    }, [visible, isPalletShipment, form]);
    // Pre-fill carrier/method only if it exists in the shipping methods list
    useEffect(function () {
        var _a;
        if (visible && shipmentData && shippingMethods.length > 0) {
            var routeSegment_1 = (_a = shipmentData.shipmentRouteSegmentList) === null || _a === void 0 ? void 0 : _a[0];
            if ((routeSegment_1 === null || routeSegment_1 === void 0 ? void 0 : routeSegment_1.carrierPartyId) && (routeSegment_1 === null || routeSegment_1 === void 0 ? void 0 : routeSegment_1.shipmentMethodEnumId)) {
                var existsInOptions = shippingMethods.some(function (m) {
                    return m.carrierPartyId === routeSegment_1.carrierPartyId &&
                        m.shipmentMethodEnumId === routeSegment_1.shipmentMethodEnumId;
                });
                if (existsInOptions) {
                    form.setFieldsValue({
                        carrierAndShipmentMethod: routeSegment_1.carrierPartyId + ":" + routeSegment_1.shipmentMethodEnumId
                    });
                }
            }
        }
    }, [visible, shipmentData, shippingMethods, form]);
    // Whether all items have been packed (totalQuantity === quantity)
    var allItemsPacked = useMemo(function () {
        if (!(shipmentItemSourceList === null || shipmentItemSourceList === void 0 ? void 0 : shipmentItemSourceList.length))
            return false;
        var totalQty = 0;
        var packedQty = 0;
        shipmentItemSourceList.forEach(function (item) {
            var _a, _b, _c;
            totalQty += (_a = item === null || item === void 0 ? void 0 : item.quantity) !== null && _a !== void 0 ? _a : 0;
            packedQty += ((_b = item === null || item === void 0 ? void 0 : item.quantity) !== null && _b !== void 0 ? _b : 0) - ((_c = item === null || item === void 0 ? void 0 : item.quantityNotHandled) !== null && _c !== void 0 ? _c : 0);
        });
        return packedQty === totalQty;
    }, [shipmentItemSourceList]);
    // Handle complete
    var handleComplete = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var values, serialized, result, hasAlreadyLabelMessage, error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (isCompleteLoading)
                        return [2 /*return*/];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 8, 9, 10]);
                    setIsSubmitting(true);
                    return [4 /*yield*/, form.validateFields()];
                case 2:
                    values = _b.sent();
                    serialized = shipmentItemDetailList === null || shipmentItemDetailList === void 0 ? void 0 : shipmentItemDetailList.some(function (item) { return (item === null || item === void 0 ? void 0 : item.serialized) === 'Y'; });
                    return [4 /*yield*/, handleMarkPacked({
                            carrierAndShipmentMethod: values.carrierAndShipmentMethod,
                            getLabels: values.getLabels,
                            getReturnLabels: values.getReturnLabels,
                            getLocalPrints: values.getLocalPrints,
                            serialized: serialized,
                            saveAsDefault: values.saveAsDefault
                        })];
                case 3:
                    result = _b.sent();
                    hasAlreadyLabelMessage = (_a = result === null || result === void 0 ? void 0 : result.messages) === null || _a === void 0 ? void 0 : _a.includes('already has label');
                    if (!serialized) return [3 /*break*/, 5];
                    return [4 /*yield*/, printPackingSlip(undefined, { context: t('Packing slip') })];
                case 4:
                    _b.sent();
                    _b.label = 5;
                case 5:
                    if (!(values.getLocalPrints && !hasAlreadyLabelMessage)) return [3 /*break*/, 7];
                    return [4 /*yield*/, printAllLabels(undefined, { context: t('All labels') })];
                case 6:
                    _b.sent();
                    _b.label = 7;
                case 7:
                    form.resetFields();
                    onClose();
                    return [3 /*break*/, 10];
                case 8:
                    error_1 = _b.sent();
                    return [3 /*break*/, 10];
                case 9:
                    setIsSubmitting(false);
                    return [7 /*endfinally*/];
                case 10: return [2 /*return*/];
            }
        });
    }); }, [
        form,
        handleMarkPacked,
        printAllLabels,
        printPackingSlip,
        isCompleteLoading,
        onClose,
        shipmentItemDetailList,
        t
    ]);
    // Shipping method dropdown options: "CarrierPartyId: Description Rate"
    var shippingMethodOptions = useMemo(function () {
        return shippingMethods.map(function (method) {
            var _a;
            return ({
                key: method.carrierPartyId + ":" + method.shipmentMethodEnumId,
                value: method.carrierPartyId + ": " + method.description + " " + ((_a = method.shippingTotal) !== null && _a !== void 0 ? _a : '')
            });
        });
    }, [shippingMethods]);
    // Order Ship By label: derived from the enumeration list
    var shipmentTypeMethod = useMemo(function () {
        var _a;
        return (_a = shipmentTypeMethods.find(function (it) { var _a, _b; return it.enumId === ((_b = (_a = shipmentData === null || shipmentData === void 0 ? void 0 : shipmentData.shipmentRouteSegmentList) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.shipmentMethodEnumId); })) === null || _a === void 0 ? void 0 : _a.description;
    }, [shipmentData, shipmentTypeMethods]);
    // Ship By must be set when the route segment doesn't have a carrier or method, otherwise will cause downstream failures
    var routeSegment = (_b = shipmentData === null || shipmentData === void 0 ? void 0 : shipmentData.shipmentRouteSegmentList) === null || _b === void 0 ? void 0 : _b[0];
    var shipByRequired = !((routeSegment === null || routeSegment === void 0 ? void 0 : routeSegment.carrierPartyId) && (routeSegment === null || routeSegment === void 0 ? void 0 : routeSegment.shipmentMethodEnumId));
    // show package defaults only for a single-package non-pallet shipment,
    // and only when the owner org is in the No Click DTC beta
    var showSaveAsDefault = noClickDtcBetaEnabled && ((_c = shipmentPackages === null || shipmentPackages === void 0 ? void 0 : shipmentPackages.length) !== null && _c !== void 0 ? _c : 0) === 1 && !isPalletShipment;
    var incompletePackages = useMemo(function () {
        var incompleteBySeqId = new Map();
        (shipmentPackages || []).forEach(function (pkg) {
            var _a, _b, _c;
            var seqId = pkg === null || pkg === void 0 ? void 0 : pkg.shipmentPackageSeqId;
            if (!seqId)
                return;
            var missingBoxType = !(pkg === null || pkg === void 0 ? void 0 : pkg.shipmentBoxTypeId);
            var missingWeight = !(pkg === null || pkg === void 0 ? void 0 : pkg.weight);
            var missingWeightUom = !(pkg === null || pkg === void 0 ? void 0 : pkg.weightUomId);
            if (!missingBoxType && !missingWeight && !missingWeightUom)
                return;
            var existing = incompleteBySeqId.get(seqId);
            incompleteBySeqId.set(seqId, {
                seqId: seqId,
                missingBoxType: ((_a = existing === null || existing === void 0 ? void 0 : existing.missingBoxType) !== null && _a !== void 0 ? _a : false) || missingBoxType,
                missingWeight: ((_b = existing === null || existing === void 0 ? void 0 : existing.missingWeight) !== null && _b !== void 0 ? _b : false) || missingWeight,
                missingWeightUom: ((_c = existing === null || existing === void 0 ? void 0 : existing.missingWeightUom) !== null && _c !== void 0 ? _c : false) || missingWeightUom
            });
        });
        return Array.from(incompleteBySeqId.values()).sort(function (a, b) {
            return String(a.seqId).localeCompare(String(b.seqId), undefined, { numeric: true });
        });
    }, [shipmentPackages]);
    // Branch: unclosed packages — show missing box/weight warnings when all items are packed
    if (incompletePackages.length > 0) {
        if (!allItemsPacked)
            return null;
        return (_jsx(Modal, __assign({ title: t('Pack Completed'), visible: visible, onCancel: onClose, footer: null }, { children: incompletePackages.map(function (pkg) { return (_jsxs(React.Fragment, { children: [pkg.missingBoxType && (_jsxs("h3", __assign({ className: 'text-red-600' }, { children: [t('Package'), " ", pkg.seqId, " ", t('missing box type')] }), void 0)), pkg.missingWeight && (_jsxs("h3", __assign({ className: 'text-red-600' }, { children: [t('Package'), " ", pkg.seqId, " ", t('missing weight')] }), void 0)), pkg.missingWeightUom && (_jsxs("h3", __assign({ className: 'text-red-600' }, { children: [t('Package'), " ", pkg.seqId, " ", t('missing weight UOM')] }), void 0))] }, pkg.seqId)); }) }), void 0));
    }
    // Branch: all packages closed — full complete-pack form
    return (_jsx(Modal, __assign({ className: 'font-inter', title: t('Pack Completed'), visible: visible, onCancel: function () {
            if (isCompleteLoading)
                return;
            onClose();
            form.resetFields();
        }, footer: null }, { children: _jsxs(Form, __assign({ form: form, initialValues: {
                getLabels: true,
                getReturnLabels: false,
                getLocalPrints: true,
                saveAsDefault: false
            }, onFinish: handleComplete }, { children: [_jsxs("div", __assign({ className: 'flex items-center' }, { children: [_jsx("div", __assign({ className: 'text-sm font-semibold m-3 w-3/12' }, { children: t('Shipping Gateway') }), void 0), _jsx("div", __assign({ className: 'text-sm m-3 w-1/2' }, { children: (_e = (_d = shipmentData === null || shipmentData === void 0 ? void 0 : shipmentData.shipmentRouteSegmentList) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.carrierPartyId }), void 0)] }), void 0), _jsxs("div", __assign({ className: 'flex items-center' }, { children: [_jsx("div", __assign({ className: 'text-sm font-semibold m-3 w-3/12' }, { children: t('Order Ship By') }), void 0), _jsxs("div", __assign({ className: 'text-sm m-3 w-1/2' }, { children: [(_g = (_f = shipmentData === null || shipmentData === void 0 ? void 0 : shipmentData.shipmentRouteSegmentList) === null || _f === void 0 ? void 0 : _f[0]) === null || _g === void 0 ? void 0 : _g.carrierPartyId, " ", shipmentTypeMethod] }), void 0)] }), void 0), _jsxs("div", __assign({ className: 'flex items-center' }, { children: [_jsx("div", __assign({ className: 'text-sm font-semibold m-3 text-green-500 w-3/12' }, { children: t('Ship By') }), void 0), _jsx("div", __assign({ className: 'text-sm m-3 w-1/2' }, { children: _jsx(Form.Item, __assign({ name: 'carrierAndShipmentMethod', rules: [{ required: shipByRequired, message: t('Please select ship by') }] }, { children: _jsx(Dropdown, { searchable: true, placeholder: t('Select One'), data: shippingMethodOptions }, void 0) }), void 0) }), void 0)] }), void 0), _jsxs("div", __assign({ className: 'flex items-center' }, { children: [_jsx("div", __assign({ className: 'text-sm font-semibold m-3 w-3/12' }, { children: t('Get Labels') }), void 0), _jsx("div", __assign({ className: 'text-sm m-3 w-1/2' }, { children: _jsx(Form.Item, __assign({ name: 'getLabels', valuePropName: 'checked' }, { children: _jsx(Checkbox, { disabled: isPalletShipment }, void 0) }), void 0) }), void 0)] }), void 0), _jsxs("div", __assign({ className: 'flex items-center' }, { children: [_jsx("div", __assign({ className: 'text-sm font-semibold m-3 w-3/12' }, { children: t('Get Return Labels') }), void 0), _jsx("div", __assign({ className: 'text-sm m-3 w-1/2' }, { children: _jsx(Form.Item, __assign({ name: 'getReturnLabels', valuePropName: 'checked' }, { children: _jsx(Checkbox, { disabled: isPalletShipment }, void 0) }), void 0) }), void 0)] }), void 0), _jsxs("div", __assign({ className: 'flex items-center' }, { children: [_jsx("div", __assign({ className: 'text-sm font-semibold m-3 w-3/12' }, { children: t('Local Print') }), void 0), _jsx("div", __assign({ className: 'text-sm m-3 w-1/2' }, { children: _jsx(Form.Item, __assign({ name: 'getLocalPrints', valuePropName: 'checked' }, { children: _jsxs(Checkbox, __assign({ disabled: isPalletShipment }, { children: ["(", t('Only if QZ print setup'), ")"] }), void 0) }), void 0) }), void 0)] }), void 0), showSaveAsDefault && (_jsxs("div", __assign({ className: 'flex items-center' }, { children: [_jsx("div", __assign({ className: 'text-sm font-semibold m-3 w-3/12' }, { children: _jsx(Tooltip, __assign({ title: t('Saves this box type, weight and ship method for future orders with exactly these items so they can auto-complete.') }, { children: _jsx("span", { children: t('Save for Auto Completing Shipment') }, void 0) }), void 0) }), void 0), _jsx("div", __assign({ className: 'text-sm m-3 w-1/2' }, { children: _jsx(Form.Item, __assign({ name: 'saveAsDefault', valuePropName: 'checked' }, { children: _jsx(Checkbox, {}, void 0) }), void 0) }), void 0)] }), void 0)), _jsx(Form.Item, { children: _jsxs("div", __assign({ className: 'flex items-center' }, { children: [_jsx("div", { className: 'text-sm font-semibold m-3 w-3/12' }, void 0), _jsx("div", __assign({ className: 'text-sm m-3 w-1/2' }, { children: _jsx(Button, { buttonText: t('Complete Pack'), loading: isCompleteLoading, isDisabled: isCompleteLoading }, void 0) }), void 0)] }), void 0) }, void 0)] }), void 0) }), void 0));
};
export default PackCompleteModal;
